function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import findIndex from 'lodash/findIndex';
import reject from 'lodash/reject';
import { registerAction, unregisterAction } from 'helpers/reducerTools';
import { SET_NEW_CONFIGURATION_VERSION } from 'modules/App/actionTypes';
import * as actionTypes from './actionTypes';
import { IDENTITY_STATUSES } from './constants';
const initialState = {
    isAuthenticated: false,
    hasElevatedPermissions: false,
    isOtpVerified: false,
    uuid: null,
    language: null,
    encryptedPrivateKey: null,
    passphrase: null,
    publicKey: null,
    loadedIdentity: null,
    invitationCode: null,
    otpStatus: null,
    otpRegion: null,
    otpSignatureToken: null,
    verifiedSignatureToken: null,
    confirmEmailActivationType: null,
    availableCountries: [],
    availableScopes: [],
    identities: [],
    identityProviders: [],
    inactiveIdentity: null,
    resetPasswordIdentity: null,
    resetPasswordEmail: null,
    resetPasswordType: null,
    invitation: null,
    invitationToken: null,
    invitationInformationTemplate: null,
    walletEntriesList: [],
    organizationMemberships: [],
    loginAudit: null,
    isConfirmTokenExpired: false,
    fetching: [],
    sending: [],
    errors: [],
    status: null
};
// eslint-disable-next-line default-param-last
export default function reducer(state = _object_spread({}, initialState), action) {
    switch(action.type){
        case actionTypes.SET_OTP:
            {
                const { otpStatus, otpRegion, otpSignatureToken } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    otpStatus,
                    otpRegion,
                    otpSignatureToken
                });
            }
        case actionTypes.CLEAR_OTP:
            {
                return _object_spread_props(_object_spread({}, state), {
                    otpStatus: null,
                    otpRegion: null,
                    otpSignatureToken: null
                });
            }
        case actionTypes.SET_VERIFIED_SIGNATURE_TOKEN:
            {
                const { verifiedSignatureToken } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    verifiedSignatureToken
                });
            }
        case actionTypes.SET_AVAILABLE_COUNTRIES:
            {
                const { countries } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    availableCountries: countries
                });
            }
        case actionTypes.SET_AVAILABLE_SCOPES:
            {
                const { scopes } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    availableScopes: scopes
                });
            }
        case actionTypes.SET_IDENTITIES:
            {
                const { identities } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    identities
                });
            }
        case actionTypes.SET_RESET_PASSWORD_IDENTITY:
            {
                const { identity } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    resetPasswordIdentity: identity
                });
            }
        case actionTypes.SET_LOADED_IDENTITY:
            {
                const { loadedIdentity } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    loadedIdentity
                });
            }
        case actionTypes.UNSET_INACTIVE_IDENTITY:
            {
                return _object_spread_props(_object_spread({}, state), {
                    inactiveIdentity: null
                });
            }
        case actionTypes.CHOOSE_COUNTRY:
            {
                const { country } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    availableCountries: [
                        country
                    ]
                });
            }
        case actionTypes.CHOOSE_SCOPE:
            {
                const { scope } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    availableScopes: [
                        scope
                    ]
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.GET_ME_SUCCESS:
            {
                const { account } = action.payload;
                if (!account) {
                    return state;
                }
                const { uuid = null, identities = [], encryptedPrivateKey = null, passphrase = null, publicKey = null, language = null, loginAudit = null, status = null } = account;
                return _object_spread_props(_object_spread({}, state), {
                    uuid,
                    identities,
                    encryptedPrivateKey,
                    passphrase,
                    publicKey,
                    language,
                    loginAudit,
                    status
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.LIST_WALLET_ENTRIES:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.LIST_WALLET_ENTRIES),
                    errors: unregisterAction(state.errors, actionTypes.LIST_WALLET_ENTRIES)
                });
            }
        case actionTypes.LIST_WALLET_ENTRIES_SUCCESS:
            {
                const { walletEntriesList } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    walletEntriesList,
                    fetching: unregisterAction(state.fetching, actionTypes.LIST_WALLET_ENTRIES)
                });
            }
        case actionTypes.LIST_WALLET_ENTRIES_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.LIST_WALLET_ENTRIES),
                    errors: registerAction(state.errors, actionTypes.LIST_WALLET_ENTRIES)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SIGN_IN:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.SIGN_IN),
                    errors: unregisterAction(state.errors, actionTypes.SIGN_IN)
                });
            }
        case actionTypes.SIGN_IN_CANCEL:
            {
                return _object_spread_props(_object_spread({}, state), {
                    isAuthenticated: false,
                    isOtpVerified: false,
                    availableCountries: [],
                    availableScopes: [],
                    otpStatus: null,
                    otpRegion: null,
                    otpSignatureToken: null,
                    sending: unregisterAction(state.sending, actionTypes.SIGN_IN)
                });
            }
        case actionTypes.SIGN_IN_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    isAuthenticated: true,
                    sending: unregisterAction(state.sending, actionTypes.SIGN_IN)
                });
            }
        case actionTypes.SIGN_IN_ERROR:
            {
                const { error } = action;
                const { inactiveIdentity } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    inactiveIdentity,
                    isAuthenticated: false,
                    isOtpVerified: false,
                    error,
                    sending: unregisterAction(state.sending, actionTypes.SIGN_IN),
                    errors: registerAction(state.errors, actionTypes.SIGN_IN)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.VERIFY_OTP:
            {
                return _object_spread_props(_object_spread({}, state), {
                    errors: unregisterAction(state.errors, actionTypes.VERIFY_OTP),
                    sending: registerAction(state.sending, actionTypes.VERIFY_OTP)
                });
            }
        case actionTypes.VERIFY_OTP_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    isOtpVerified: true,
                    errors: unregisterAction(state.errors, actionTypes.VERIFY_OTP),
                    sending: unregisterAction(state.sending, actionTypes.VERIFY_OTP)
                });
            }
        case actionTypes.VERIFY_OTP_ERROR:
            {
                const { failedAttempts, lockoutEnd } = action.payload;
                const otpStatus = _object_spread_props(_object_spread({}, state.otpStatus), {
                    failedAttempts,
                    lockoutEnd
                });
                return _object_spread_props(_object_spread({}, state), {
                    otpStatus,
                    errors: registerAction(state.errors, actionTypes.VERIFY_OTP),
                    sending: unregisterAction(state.sending, actionTypes.VERIFY_OTP)
                });
            }
        case actionTypes.RESEND_OTP_SUCCESS:
            {
                const { otpSignatureToken } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    otpSignatureToken
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SIGN_UP:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.SIGN_UP),
                    errors: unregisterAction(state.errors, actionTypes.SIGN_UP)
                });
            }
        case actionTypes.SIGN_UP_SUCCESS:
            {
                const { inactiveIdentity } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    inactiveIdentity,
                    sending: unregisterAction(state.sending, actionTypes.SIGN_UP)
                });
            }
        case actionTypes.SIGN_UP_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.SIGN_UP),
                    errors: registerAction(state.errors, actionTypes.SIGN_UP)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SIGN_OUT:
            {
                return _object_spread_props(_object_spread({}, state), {
                    isAuthenticated: false,
                    sending: registerAction(state.sending, actionTypes.SIGN_OUT),
                    errors: unregisterAction(state.errors, actionTypes.SIGN_OUT)
                });
            }
        case actionTypes.SIGN_OUT_SUCCESS:
            {
                return _object_spread({}, initialState);
            }
        case actionTypes.SIGN_OUT_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.SIGN_OUT),
                    errors: registerAction(state.errors, actionTypes.SIGN_OUT)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SIGN_OUT_CALLBACK:
            {
                return _object_spread_props(_object_spread({}, state), {
                    isAuthenticated: false,
                    sending: registerAction(state.sending, actionTypes.SIGN_OUT_CALLBACK),
                    errors: unregisterAction(state.errors, actionTypes.SIGN_OUT_CALLBACK)
                });
            }
        case actionTypes.SIGN_OUT_CALLBACK_SUCCESS:
            {
                return _object_spread({}, initialState);
            }
        case actionTypes.SIGN_OUT_CALLBACK_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.SIGN_OUT_CALLBACK),
                    errors: registerAction(state.errors, actionTypes.SIGN_OUT_CALLBACK)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_IDENTITY_PROVIDERS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_IDENTITY_PROVIDERS),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_IDENTITY_PROVIDERS)
                });
            }
        case actionTypes.FETCH_IDENTITY_PROVIDERS_SUCCESS:
            {
                const { identityProviders } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    identityProviders,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_IDENTITY_PROVIDERS)
                });
            }
        case actionTypes.FETCH_IDENTITY_PROVIDERS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_IDENTITY_PROVIDERS),
                    errors: registerAction(state.errors, actionTypes.FETCH_IDENTITY_PROVIDERS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_IDENTITIES:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_IDENTITIES),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_IDENTITIES)
                });
            }
        case actionTypes.FETCH_IDENTITIES_SUCCESS:
            {
                const { identities } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    identities,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_IDENTITIES)
                });
            }
        case actionTypes.FETCH_IDENTITIES_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_IDENTITIES),
                    errors: registerAction(state.errors, actionTypes.FETCH_IDENTITIES)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SWITCH_IDENTITY:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.SWITCH_IDENTITY),
                    errors: unregisterAction(state.errors, actionTypes.SWITCH_IDENTITY)
                });
            }
        case actionTypes.SWITCH_IDENTITY_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.SWITCH_IDENTITY)
                });
            }
        case actionTypes.SWITCH_IDENTITY_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.SWITCH_IDENTITY),
                    errors: registerAction(state.errors, actionTypes.SWITCH_IDENTITY)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.CONFIRM_EMAIL:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.CONFIRM_EMAIL),
                    errors: unregisterAction(state.errors, actionTypes.CONFIRM_EMAIL)
                });
            }
        case actionTypes.CONFIRM_EMAIL_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.CONFIRM_EMAIL)
                });
            }
        case actionTypes.CONFIRM_EMAIL_ERROR:
            {
                const { error } = action;
                const isConfirmTokenExpired = error.businessError && error.businessError.code === 'TokenExpired';
                return _object_spread_props(_object_spread({}, state), {
                    isConfirmTokenExpired,
                    sending: unregisterAction(state.sending, actionTypes.CONFIRM_EMAIL),
                    errors: registerAction(state.errors, actionTypes.CONFIRM_EMAIL)
                });
            }
        case actionTypes.SET_CONFIRM_EMAIL_ACTIVATION_TYPE:
            {
                const { confirmEmailActivationType } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    confirmEmailActivationType
                });
            }
        case actionTypes.UNSET_CONFIRM_EMAIL_ACTIVATION_TYPE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    confirmEmailActivationType: null
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS)
                });
            }
        case actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS_SUCCESS:
            {
                const { organizationMemberships } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    organizationMemberships,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS)
                });
            }
        case actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS),
                    errors: registerAction(state.errors, actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.APPROVE_ORGANIZATION_MEMBERSHIP:
            {
                const { organizationMembership } = action.payload;
                const { organizationUID } = organizationMembership;
                const actionType = `${actionTypes.APPROVE_ORGANIZATION_MEMBERSHIP}-${organizationUID}`;
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionType),
                    errors: unregisterAction(state.errors, actionType)
                });
            }
        case actionTypes.APPROVE_ORGANIZATION_MEMBERSHIP_SUCCESS:
            {
                const { organizationMembership } = action.payload;
                const { organizationUID } = organizationMembership;
                const idx = findIndex(state.organizationMemberships, {
                    organizationUID
                });
                const organizationMemberships = [
                    ...state.organizationMemberships
                ];
                if (idx >= 0) {
                    organizationMemberships[idx] = organizationMembership;
                } else {
                    organizationMemberships.push(organizationMembership);
                }
                const actionType = `${actionTypes.APPROVE_ORGANIZATION_MEMBERSHIP}-${organizationUID}`;
                return _object_spread_props(_object_spread({}, state), {
                    organizationMemberships,
                    sending: unregisterAction(state.sending, actionType)
                });
            }
        case actionTypes.APPROVE_ORGANIZATION_MEMBERSHIP_ERROR:
            {
                const { organizationMembership } = action.payload;
                const { organizationUID } = organizationMembership;
                const actionType = `${actionTypes.APPROVE_ORGANIZATION_MEMBERSHIP}-${organizationUID}`;
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionType),
                    errors: registerAction(state.errors, actionType)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.REJECT_ORGANIZATION_MEMBERSHIP:
            {
                const { organizationMembership } = action.payload;
                const { organizationUID } = organizationMembership;
                const actionType = `${actionTypes.REJECT_ORGANIZATION_MEMBERSHIP}-${organizationUID}`;
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionType),
                    errors: unregisterAction(state.errors, actionType)
                });
            }
        case actionTypes.REJECT_ORGANIZATION_MEMBERSHIP_SUCCESS:
            {
                const { organizationMembership } = action.payload;
                const { organizationUID } = organizationMembership;
                const organizationMemberships = reject(state.organizationMemberships, {
                    organizationUID
                });
                const actionType = `${actionTypes.REJECT_ORGANIZATION_MEMBERSHIP}-${organizationUID}`;
                return _object_spread_props(_object_spread({}, state), {
                    organizationMemberships,
                    sending: unregisterAction(state.sending, actionType)
                });
            }
        case actionTypes.REJECT_ORGANIZATION_MEMBERSHIP_ERROR:
            {
                const { organizationMembership } = action.payload;
                const { organizationUID } = organizationMembership;
                const actionType = `${actionTypes.REJECT_ORGANIZATION_MEMBERSHIP}-${organizationUID}`;
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionType),
                    errors: registerAction(state.errors, actionType)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_INVITATION:
            {
                return _object_spread_props(_object_spread({}, state), {
                    informationTemplate: null,
                    fetching: registerAction(state.fetching, actionTypes.SET_INVITATION),
                    errors: unregisterAction(state.errors, actionTypes.SET_INVITATION)
                });
            }
        case actionTypes.SET_INVITATION_SUCCESS:
            {
                const { invitation, invitationToken } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    invitation,
                    invitationToken,
                    fetching: unregisterAction(state.fetching, actionTypes.SET_INVITATION)
                });
            }
        case actionTypes.SET_INVITATION_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.SET_INVITATION),
                    errors: registerAction(state.errors, actionTypes.SET_INVITATION)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.ACCEPT_INVITATION:
        case actionTypes.ACCEPT_INVITATION_WITH_NEW_PROFILE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.ACCEPT_INVITATION),
                    errors: unregisterAction(state.errors, actionTypes.ACCEPT_INVITATION)
                });
            }
        case actionTypes.ACCEPT_INVITATION_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    invitation: null,
                    invitationToken: null,
                    invitationInformationTemplate: null,
                    sending: unregisterAction(state.sending, actionTypes.ACCEPT_INVITATION)
                });
            }
        case actionTypes.ACCEPT_INVITATION_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.ACCEPT_INVITATION),
                    errors: registerAction(state.errors, actionTypes.ACCEPT_INVITATION)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.REJECT_INVITATION:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.REJECT_INVITATION),
                    errors: unregisterAction(state.errors, actionTypes.REJECT_INVITATION)
                });
            }
        case actionTypes.REJECT_INVITATION_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    invitation: null,
                    invitationToken: null,
                    invitationInformationTemplate: null,
                    sending: unregisterAction(state.sending, actionTypes.REJECT_INVITATION)
                });
            }
        case actionTypes.REJECT_INVITATION_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.REJECT_INVITATION),
                    errors: registerAction(state.errors, actionTypes.REJECT_INVITATION)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_INVITATION_INFORMATION_TEMPLATE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_INVITATION_INFORMATION_TEMPLATE),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_INVITATION_INFORMATION_TEMPLATE)
                });
            }
        case actionTypes.FETCH_INVITATION_INFORMATION_TEMPLATE_SUCCESS:
            {
                const { invitationInformationTemplate } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    invitationInformationTemplate,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_INVITATION_INFORMATION_TEMPLATE)
                });
            }
        case actionTypes.FETCH_INVITATION_INFORMATION_TEMPLATE_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    informationTemplate: null,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_INVITATION_INFORMATION_TEMPLATE),
                    errors: registerAction(state.errors, actionTypes.FETCH_INVITATION_INFORMATION_TEMPLATE)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.CHANGE_PASSWORD:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.CHANGE_PASSWORD),
                    errors: unregisterAction(state.errors, actionTypes.CHANGE_PASSWORD)
                });
            }
        case actionTypes.CHANGE_PASSWORD_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.CHANGE_PASSWORD)
                });
            }
        case actionTypes.CHANGE_PASSWORD_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.CHANGE_PASSWORD),
                    errors: registerAction(state.errors, actionTypes.CHANGE_PASSWORD)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.RESET_PASSWORD:
            {
                const { email: resetPasswordEmail } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    resetPasswordEmail,
                    sending: registerAction(state.sending, actionTypes.RESET_PASSWORD),
                    errors: unregisterAction(state.errors, actionTypes.RESET_PASSWORD)
                });
            }
        case actionTypes.SET_RESET_PASSWORD_TYPE:
            {
                const { resetPasswordType } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    resetPasswordType
                });
            }
        case actionTypes.RESET_PASSWORD_CANCEL:
        case actionTypes.RESET_PASSWORD_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.RESET_PASSWORD)
                });
            }
        case actionTypes.RESET_PASSWORD_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    resetPasswordType: null,
                    sending: unregisterAction(state.sending, actionTypes.RESET_PASSWORD),
                    errors: registerAction(state.errors, actionTypes.RESET_PASSWORD)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_PASSWORD:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.SET_PASSWORD)
                });
            }
        case actionTypes.SET_NEW_PASSWORD:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.SET_NEW_PASSWORD),
                    errors: unregisterAction(state.errors, actionTypes.SET_NEW_PASSWORD)
                });
            }
        case actionTypes.SET_NEW_PASSWORD_CANCEL:
            {
                return _object_spread_props(_object_spread({}, state), {
                    availableCountries: [],
                    sending: unregisterAction(state.sending, actionTypes.SET_NEW_PASSWORD)
                });
            }
        case actionTypes.SET_NEW_PASSWORD_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.SET_NEW_PASSWORD, actionTypes.SET_PASSWORD)
                });
            }
        case actionTypes.SET_NEW_PASSWORD_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.SET_NEW_PASSWORD, actionTypes.SET_PASSWORD),
                    errors: registerAction(state.errors, actionTypes.SET_NEW_PASSWORD)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_NEW_PASSWORD_CC:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.SET_NEW_PASSWORD_CC),
                    errors: unregisterAction(state.errors, actionTypes.SET_NEW_PASSWORD_CC)
                });
            }
        case actionTypes.SET_NEW_PASSWORD_CC_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.SET_NEW_PASSWORD_CC)
                });
            }
        case actionTypes.SET_NEW_PASSWORD_CC_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.SET_NEW_PASSWORD_CC),
                    errors: registerAction(state.errors, actionTypes.SET_NEW_PASSWORD_CC)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_ELEVATED_PERMISSIONS_MODE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    elevatedPermissionsMode: action.payload,
                    hasElevatedPermissions: false
                });
            }
        case actionTypes.ELEVATE_PERMISSIONS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.ELEVATE_PERMISSIONS),
                    errors: unregisterAction(state.errors, actionTypes.ELEVATE_PERMISSIONS)
                });
            }
        case actionTypes.ELEVATE_PERMISSIONS_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    hasElevatedPermissions: true,
                    sending: unregisterAction(state.sending, actionTypes.ELEVATE_PERMISSIONS)
                });
            }
        case actionTypes.ELEVATE_PERMISSIONS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    hasElevatedPermissions: false,
                    sending: unregisterAction(state.sending, actionTypes.ELEVATE_PERMISSIONS),
                    errors: registerAction(state.errors, actionTypes.ELEVATE_PERMISSIONS)
                });
            }
        case actionTypes.ELEVATE_PERMISSIONS_TIMEOUT:
            {
                return _object_spread_props(_object_spread({}, state), {
                    hasElevatedPermissions: false
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.PASSPHRASE_RECOVERY:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.PASSPHRASE_RECOVERY),
                    errors: unregisterAction(state.errors, actionTypes.PASSPHRASE_RECOVERY)
                });
            }
        case actionTypes.PASSPHRASE_RECOVERY_SUCCESS:
            {
                const { passphrase } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    passphrase,
                    sending: unregisterAction(state.sending, actionTypes.PASSPHRASE_RECOVERY)
                });
            }
        case actionTypes.PASSPHRASE_RECOVERY_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.PASSPHRASE_RECOVERY),
                    errors: registerAction(state.errors, actionTypes.PASSPHRASE_RECOVERY)
                });
            }
        // BackOffice UPDATE -----------------------------------------------------------------------------------------------
        case SET_NEW_CONFIGURATION_VERSION:
            {
                const { identityProviders } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    identityProviders
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.DELETE_ACCOUNT:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.DELETE_ACCOUNT),
                    errors: unregisterAction(state.errors, actionTypes.DELETE_ACCOUNT)
                });
            }
        case actionTypes.DELETE_ACCOUNT_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    status: IDENTITY_STATUSES.DELETED,
                    sending: unregisterAction(state.sending, actionTypes.DELETE_ACCOUNT)
                });
            }
        case actionTypes.DELETE_ACCOUNT_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.DELETE_ACCOUNT),
                    errors: registerAction(state.errors, actionTypes.DELETE_ACCOUNT)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.EDIT_GUARDIAN_EMAIL:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.EDIT_GUARDIAN_EMAIL),
                    errors: unregisterAction(state.errors, actionTypes.EDIT_GUARDIAN_EMAIL)
                });
            }
        case actionTypes.EDIT_GUARDIAN_EMAIL_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.EDIT_GUARDIAN_EMAIL)
                });
            }
        case actionTypes.EDIT_GUARDIAN_EMAIL_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.EDIT_GUARDIAN_EMAIL),
                    errors: registerAction(state.errors, actionTypes.EDIT_GUARDIAN_EMAIL)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.CHECK_CONFIRM_TERMS_OF_SERVICES_BY_GUARDIAN:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.CHECK_CONFIRM_TERMS_OF_SERVICES_BY_GUARDIAN),
                    errors: unregisterAction(state.errors, actionTypes.CHECK_CONFIRM_TERMS_OF_SERVICES_BY_GUARDIAN)
                });
            }
        case actionTypes.CHECK_CONFIRM_TERMS_OF_SERVICES_BY_GUARDIAN_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.CHECK_CONFIRM_TERMS_OF_SERVICES_BY_GUARDIAN)
                });
            }
        case actionTypes.CHECK_CONFIRM_TERMS_OF_SERVICES_BY_GUARDIAN_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.CHECK_CONFIRM_TERMS_OF_SERVICES_BY_GUARDIAN),
                    errors: registerAction(state.errors, actionTypes.CHECK_CONFIRM_TERMS_OF_SERVICES_BY_GUARDIAN)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.UPDATE_ACCOUNT_SETTINGS_SUCCESS:
            {
                const { language } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    language
                });
            }
        case actionTypes.CLEAR_ERRORS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    errors: []
                });
            }
        default:
            {
                return state;
            }
    }
}
